export const SET_WATCH_BATTLE_PLAYERS = 'SET_WATCH_BATTLE_PLAYERS'
export const UNSET_WATCH_BATTLE_PLAYERS = 'UNSET_WATCH_BATTLE_PLAYERS'